// extracted by mini-css-extract-plugin
export default {"wrapper":"dw-z","button":"ew-z","alternate":"fw-z","disabled":"gw-z","paymentWarning":"hw-z","fadeIn":"iw-z"};